import BasicApiFormatter from '@modules/basic-api-formatter';

const FILENAME_REGEX = /attachment;.*filename="(.*)"/i;
/**
 *
 *
 */
class DownloadApiFormatter {
  /**
   *
   * @param {*} payload
   * @return {Object}
   */
  static pack(payload) {
    const headers = new Headers();
    const body = new FormData();

    headers.append('Accept', '*/*');
    headers.append('X-Requested-By', 'Enterprise');

    if (typeof payload !== 'undefined') {
      body.append('arguments', JSON.stringify(payload));
    }

    return BasicApiFormatter.getRequestConfig(headers, body);
  }

  /**
   *
   * @param {*} response
   * @return {Promise}
   */
  static unpack(response) {
    const contentDisposition = response.headers.get('content-disposition');
    const filenameMatches = FILENAME_REGEX.exec(contentDisposition);
    return response.blob()
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        if (filenameMatches !== null) {
          a.download = filenameMatches[1];
        }
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  }
}

export default DownloadApiFormatter;
